import { apiRequest } from "../client";
import { buildPulseHeartbeatBody, type PulseApiClientErrorBody, type PulseHeartbeatBody } from "@/utils/pulseTelemetry";
import type { ModulePermissions, UserProfile, UserInfo } from "./types";

export type { PulseApiClientErrorBody, PulseHeartbeatBody };

// Re-export types
export type { ModulePermissions, UserProfile };

/**
 * Get the current user's module permissions
 */
export const getModulePermissions = async (): Promise<ModulePermissions> => {
  return apiRequest<ModulePermissions>({
    method: "GET",
    url: "/security/user/modules",
  });
};

/**
 * Get the current user's profile
 */
export const getCurrentUser = async (): Promise<UserProfile> => {
  return apiRequest<UserProfile>({
    method: "GET",
    url: "/security/user/profile",
  });
};

/**
 * Get the current user's security
 */
export const getCurrentUserInfo = async (route?: string): Promise<UserInfo> => {
  const url = new URL("/security/user/info", window.location.origin);
  if (route) {
    url.searchParams.append("route", route);
  }
  return apiRequest<UserInfo>({
    method: "GET",
    url: url.pathname + url.search,
  });
};

/** Tab-visible heartbeat for Opulse (lightweight vs full user/info). */
export const recordPulseHeartbeat = async (route?: string): Promise<void> => {
  const data: PulseHeartbeatBody = buildPulseHeartbeatBody(route);
  await apiRequest<void>({
    method: "POST",
    url: "/security/user/pulse-heartbeat",
    data,
  });
};

/** Sampled axios / network failure for Opulse friction lane. */
export const recordPulseApiClientError = async (
  params: PulseApiClientErrorBody,
): Promise<void> => {
  await apiRequest<void>({
    method: "POST",
    url: "/security/user/pulse-api-client-error",
    data: params,
  });
};

/** Sampled client error for Opulse triage lane. */
export const recordPulseClientError = async (params: {
  route?: string;
  error_class?: string;
  sentry_event_id?: string;
}): Promise<void> => {
  await apiRequest<void>({
    method: "POST",
    url: "/security/user/pulse-error",
    data: params,
  });
};
